import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Body1, Stack } from '@myphx-engineering/phx-design-system';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import { CoverageStatus } from '../../../../graphql/generated/graphql';

export const InsuranceCoverageDescription: FC = () => {
    const { t } = useTranslation('lilly');
    const { coverage } = useFillPrescription();

    if (coverage === CoverageStatus.PriorAuthRequired) {
        return (
            <Stack gap="sm" data-testid="path-select-description">
                <Body1>{t('fill.insurance.pathSelect.priorAuth.line1')}</Body1>
                <Body1>
                    <Trans
                        t={t}
                        i18nKey="fill.insurance.pathSelect.priorAuth.line2"
                        components={{ 1: <strong /> }}
                    />
                </Body1>
            </Stack>
        );
    }

    return null;
};
